import { connect } from 'react-redux';

import SiteViewerVersionComponentSelector from './site_viewer_version_component_selector.jsx';

import { getSiteViewerVersion } from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state)=> {
  const siteViewerVersion = getSiteViewerVersion(state);

  return { siteViewerVersion };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteViewerVersionComponentSelector);
